/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import SendReport from "./components/SendReport";

export default function App() {
  return (
    <div>
      <h1
        style={{
          fontWeight: 700,
          fontSize: "1.6rem",
          lineHeight: "2rem",
        }}
      >
        Generate & Send Report
      </h1>
      <SendReport />
    </div>
  );
}
